/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropcreate1Inputs */

const en_dropcreate1 = /** @type {(inputs: Dropcreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New drop`)
};

const de_dropcreate1 = /** @type {(inputs: Dropcreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Drop`)
};

/**
* | output |
* | --- |
* | "New drop" |
*
* @param {Dropcreate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropcreate1 = /** @type {((inputs?: Dropcreate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropcreate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropcreate1(inputs)
	return de_dropcreate1(inputs)
});
export { dropcreate1 as "dropCreate" }